export const THEME_KEY = 'orcaAi.theme';

/** @typedef {'light' | 'dark'} ThemePreference */

/** @returns {ThemePreference} */
export function readThemePreference() {
  try {
    const value = localStorage.getItem(THEME_KEY);
    if (value === 'light' || value === 'dark') return value;
  } catch {
    // ignore quota / private mode
  }
  return 'dark';
}

/** @param {ThemePreference} [preference] */
export function resolveTheme(preference = readThemePreference()) {
  return preference;
}

/** @param {'light' | 'dark'} resolved */
export function applyTheme(resolved) {
  const root = document.documentElement;
  root.classList.add('orca-theme');
  root.classList.remove('orca-theme-dark', 'orca-theme-light');
  root.classList.add(resolved === 'light' ? 'orca-theme-light' : 'orca-theme-dark');

  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute('content', resolved === 'light' ? '#f1f4f8' : '#0f1218');
  }
}

export function initTheme() {
  applyTheme(resolveTheme());
}

/** @param {ThemePreference} preference */
export function setThemePreference(preference) {
  try {
    localStorage.setItem(THEME_KEY, preference);
  } catch {
    // ignore
  }
  applyTheme(resolveTheme(preference));
}

const CYCLE_ORDER = /** @type {const} */ (['light', 'dark']);

/** @param {ThemePreference} current */
export function cycleThemePreference(current) {
  const next = CYCLE_ORDER[(CYCLE_ORDER.indexOf(current) + 1) % CYCLE_ORDER.length];
  setThemePreference(next);
  return next;
}
